// Module-level permission slugs and routing targets for Financial Hub access control.
// Permissions are hierarchical: `financial-hub` -> `financial-hub/<section>` -> `.../<role>`.
// Access is resolved by PREFIX (HasPermissionsService.hasModuleAccess), not by leaf-role slug,
// so holding any role under a section grants access to that section.

// Root module slug — matches the `module` route data on the Financial Hub root route and the
// `environment.modules.financialHub` value.
export const FINANCIAL_HUB_MODULE = 'financial-hub';

// Section module slugs — match the `module` route data on each section wrapper route.
export const FINANCIAL_HUB_SECTION = {
  COMPANIES:        'financial-hub/companies',
  PURCHASE_ORDERS:  'financial-hub/purchase-orders',
} as const;
export type FinancialHubSection = typeof FINANCIAL_HUB_SECTION[keyof typeof FINANCIAL_HUB_SECTION];

// Ordered sections used to resolve where to send a user who lacks access to the requested
// section: the guard redirects to the first section in this list the user CAN access. Order
// mirrors the empty-path redirect (purchase-orders first), so a user with both lands on PO.
export const FINANCIAL_HUB_SECTIONS: ReadonlyArray<{ module: FinancialHubSection; path: string }> = [
  { module: FINANCIAL_HUB_SECTION.PURCHASE_ORDERS, path: '/financial-hub/purchase-orders' },
  { module: FINANCIAL_HUB_SECTION.COMPANIES,       path: '/financial-hub/companies' },
];

// Where to send a user with no access to any Financial Hub section.
export const FINANCIAL_HUB_FALLBACK_PATH = '/account';
